
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine } from "@common/src/utils/common";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import { splitThousands } from "@common/src/utils/common";
import DataImport from "@common/src/components/scope/data-import/index.vue";
import t from "@common/src/i18n/t";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";
import { addCurrencyUnit } from "@common/src/utils/tools";
import MyCheckbox from "@common/src/components/scope/my-checkbox/index.vue";
import { InjectFunction } from "@common/src/utils/decorator";

const serviceItem = namespace("service-item");
const common_base = namespace("common_base");
@InjectFunction("appCode", "permitApp")
@Component({
  components: { StandardFlag, DataImport, SwitchStatus, MyCheckbox }
})
@Table("loadListData")
@Table.DataImport({
  templateUrl: "https://static.gtech.asia/static/speedbiz/template/2.7/服务项目导入.xlsx",
  actionUrl: "/filecloud/importServiceItems"
})
@TableRowsSelect({
  warningMsg: t("setting.select-test-item"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class Service extends Vue {
  @serviceItem.Action getServiceItemList;
  @serviceItem.Action updateServiceItemStatus;
  @serviceItem.Action queryTwoLevelClassList;
  @common_base.State showPlatformServiceItem;
  addCurrencyUnit = addCurrencyUnit;
  t = t;
  searchForm = {
    partsName: "",
    partsNumber: "",
    brandCode: "",
    serviceCategoryCode: ""
  };
  serviceList: any[] = [];
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.prop === "categoryCode" ? item.value[item.value.length - 1] : item.value;
      }
    });
    this.loadListData();
  }
  serviceItemTypeList: any = [];
  get searchList() {
    return [
      {
        label: t("setting.project-name"),
        type: "input",
        value: "",
        prop: "serviceName"
      },
      {
        label: t("test.item-code"),
        type: "input",
        value: "",
        prop: "serviceNumber"
      },
      {
        label: t("setting.classification-service"),
        type: "select",
        selectList: this.serviceItemTypeList,
        value: "",
        prop: "serviceCategoryCode"
      }
    ];
  }
  created() {
    this.loadListData();
    this.queryTwoLevelClassList({
      serviceCategoryName: "",
      serviceClass: "",
      pageSize: 999,
      pageNum: 1
    }).then(data => {
      this.serviceItemTypeList = this.$safeValue(data, "data.list").map(item => {
        item.label = item.serviceCategoryName;
        item.value = item.serviceCategoryCode;
        return item;
      });
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getServiceItemList({
      ...this.searchForm,
      status: "9",
      orderItems: this.mix_sortParams,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum,
      notOpadmin: this.showPlatformServiceItem ? "0" : "1"
    }).then(data => {
      this.serviceList = data.data.list;
      return data;
    });
  }
  handleEdit(row) {
    this.$router.push(`/setting/service-edit/${row.serviceCode}`);
  }
  @TableRowsSelect.updateMethod
  confirmUpdateStatus(status, selectedRow) {
    return this.updateServiceItemStatus({
      status: status,
      serviceCodeList: selectedRow ? [selectedRow.serviceCode] : this.mix_selectedRows.map(item => item.serviceCode)
    }).then(() => {
      this.$message.success(status ? t("setting.enable-successful") : t("setting.disable-success"));
      this.loadListData();
    });
  }
  handleOpServiceItemShowChange() {
    this.loadListData();
  }
}
